var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoldingEntity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20H7C6.44772 20 6 19.5523 6 19V5H17C17.5523 5 18 5.44772 18 6V10.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8421 13C13.7004 13.7868 13.2604 14.4995 12.7592 15.091C12.2812 15.6551 11.7112 16.1735 11.0706 16.5281C10.5957 16.791 10.0925 16.9871 9.55096 16.9994C9.21844 17.0069 9.00869 16.948 9.00035 16.5562C8.98508 15.8389 9.47796 15.2598 10.0208 14.879C10.6815 14.4155 11.4735 14.1292 12.2722 14.1292C12.6084 14.1292 12.942 14.1549 13.1593 14.4498C13.343 14.699 13.497 14.9731 13.7001 15.206C13.8933 15.4274 14.1658 15.6226 14.4514 15.6773C15.0369 15.7895 15.6053 15.8268 16.1718 15.6211C16.4991 15.5023 16.8022 15.3294 17.1188 15.1843C17.2616 15.1188 17.3685 15.0737 17.525 15.1204C17.8676 15.2226 18.1322 15.5366 18.428 15.731C18.8033 15.9777 19.2242 16.1122 19.6565 15.9609C19.9999 15.8408 20.3153 15.6463 20.6549 15.5164C20.7662 15.4738 20.896 15.4685 21 15.4142",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldingEntity);
export default __webpack_public_path__ + "static/media/holding-entity.93c8e30d36234d3330dcb00d28214b1e.svg";
export { ForwardRef as ReactComponent };